import React, { useContext, useEffect, useState, useCallback } from "react";
import { Container, Typography, Box, useTheme } from "@mui/material";
import data from "../../data";
import { AppContext } from "../../context/AppContext";
import Question from "../Question";
import colors from "../../color";
import { Trans, useTranslation } from "react-i18next";

function QuestionnaireScreen({ questionnaireId = 0 }) {
  const { setQuestionnaire } = useContext(AppContext);
  const [questionnaire, setLocalQuestionnaire] = useState(null);

  useEffect(() => {
    if (!data) {
      console.error("Data is undefined");
      return;
    }

    const foundQuestionnaire = data.find((q) => q.questionnaireId === questionnaireId.toString());
    if (foundQuestionnaire) {
      const clonedQuestionnaire = {
        ...foundQuestionnaire,
        answers: [],
      };

      setLocalQuestionnaire(clonedQuestionnaire);
      setQuestionnaire(clonedQuestionnaire); // Ensure this only runs once
    }
  }, [questionnaireId]);

  if (!questionnaire) {
    return <div>Loading...</div>;
  }

  return <QuestionnaireContent questionnaire={questionnaire} />;
}

function QuestionnaireContent({ questionnaire }) {
  const { saveChoice, getAnswers } = useContext(AppContext);
  const { t } = useTranslation();
  const theme = useTheme();

  const handleUpdates = useCallback(
    (choice, questionId) => {
      saveChoice(choice, questionId, questionnaire);
    },
    [saveChoice, questionnaire] // Dependencies for the callback
  );

  const answers = React.useMemo(() => {
    return questionnaire.questionnaireId ? getAnswers(questionnaire.questionnaireId) : [];
  }, [questionnaire.questionnaireId, getAnswers]);

  return (
    <Container style={{ padding: "0px" }}>
      <Typography
        variant="h6"
        style={{
          marginBottom: "10px",
        }}
      >
        {t(questionnaire.questionnaireDescription)}
      </Typography>
      <Typography
        variant="body1"
        style={{
          marginBottom: "10px",
          color: colors.textPrimary,
        }}
      >
        {questionnaire.questionnaireId === "0" ? (
          t("questionnaire_instruction_1")
        ) : (
          <Trans
            i18nKey="questionnaire_instruction_2"
            values={{ value: t(questionnaire.questionnaireDescription) }}
            components={{ strong: <strong /> }}
          />
        )}
      </Typography>
      {questionnaire.questionnaireQuestions.map((item, index) => (
        <Box
          key={item.questionId}
          sx={{
            marginBottom: "10px",
          }}
        >
          <Question
            question={item}
            number={index + 1}
            onChange={handleUpdates}
            currentValue={answers.find((q) => q.id === item.questionId)?.text}
          />
        </Box>
      ))}
    </Container>
  );
}

export default QuestionnaireScreen;
